// Libraries
var React = require('react');
var PubSub = require('pubsub-js');
var $ = require('jquery');

// Styles
require('./LiveGameSummary.scss');

// Assets
var spinner = require('images/Rolling.svg');

// Components
var LatestScores = require('./LatestScores');
var Penalties = require('./Penalties');
var LatestResults = require('./LatestResults');
var Realtime = null;

class LiveGameSummaryModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			showSelf: false,
			showPenalties: false,
			showScorers: false,
			penaltyShootOutOccurring: false,
			showSpinner: true,
			showError: false,
			awayCrestUrl: "",
			homeCrestUrl: "",
			displayMinute: "",
			homeName: "",
			awayName: "",
			homeShortName: "",
			awayShortName: "",
			penalties: [],
			homeScorers: [],
			awayScorers: [],
			latestResults: [],

			showAggregateScore: false,
			aggregateScore: ""
		};

		PubSub.subscribe('StartMdc', this.startMdcHandler);
	}

	componentDidMount = () => {
		// delay the load of the realtime library until it's reached the browser 
		// to avoid server side rendering errors
		Realtime = require('Realtime/Realtime');

		this.loadHighlights();
		this.loadLatestScores();
		this.attachChannels();

		$(document).ajaxComplete(() => {
			this.setState({showSpinner: false}, window.LazyLoad.concat);
		});

		$(document).ajaxError(() => {
			this.setState({showError: true});
		});
	}

	handleBack = () => {
		this.setState({showPenalties: !this.state.showPenalties}, window.LazyLoad.concat);
	}

	startMdcHandler = () => {
		this.setState({showSelf: true});
	}

	loadHighlights = () => {
		$.ajax({
			method: "GET",
			url: this.props.data.endpoints.find(x => x.name === "highlights").url
		})
			.done(data => {
				if(data && data.Items) {
					this.populatePenalties(data.Items);
				}
				if(data.HomeCrestUrl && data.AwayCrestUrl) {
					this.setState({
						homeCrestUrl: this.props.data.baseUrl + data.HomeCrestUrl,
						awayCrestUrl: this.props.data.baseUrl + data.AwayCrestUrl
					});
				}
			});
	}

	loadLatestScores = () => {
		$.ajax({
			method: "GET", 
			url: this.props.data.endpoints.find(x => x.name === "latestScore").url
		})
			.done(data => {
				if(data) {
					this.populateLatestScores(data);
				}            
			});
	}

	attachChannels = () => {
		var highlightsChannel = this.props.data.endpoints.find(x => x.name === "highlights").channelId;
		var latestScoresChannel = this.props.data.endpoints.find(x => x.name === "latestScore").channelId;
		var latestResultsChannel = this.props.data.endpoints.find(x => x.name === "latestResults").channelId;

		Realtime.subscribe(highlightsChannel, this.props.data.realtimeKey, (message) => {
			this.deletePenalties(message.data.Deleted);
			this.populatePenalties(message.data.Updated, true);
		});        

		Realtime.subscribe(latestScoresChannel, this.props.data.realtimeKey, (message) => {
			this.populateLatestScores(message.data);
			console.log(message);
		});

		Realtime.subscribe(latestResultsChannel, this.props.data.realtimeKey, (message) => {
			this.populateLatestResults(message.data);
			console.log(message);
		});
	}

	populatePenalties = (highlights, update) => {
		if(highlights.some(x => x.HighlightType === "PenaltyShot")) {
			var penalties = this.state.penalties;
			var penaltiesToAdd = highlights.reverse().filter(x => x.HighlightType === "PenaltyShot");
			if(update) {
				penaltiesToAdd.forEach((current, index, array) => {
					if(penalties.findIndex(x => x.Id === current.Id) === -1) {
						penalties.push(current);
					}
				});
			} else {
				penalties = highlights.filter(x => x.HighlightType === "PenaltyShot");
			}
			this.setState({
				showPenalties: true, 
				penaltyShootOutOccurring: true, 
				penalties: penalties});
		}
	}

	deletePenalties = (highlightsToDelete) => {
		if(highlightsToDelete.some(x => x.HighlightType === "PenaltyShot")) {
			var penalties = this.state.penalties;
			var penaltiesToDelete = highlightsToDelete.filter(x => x.HighlightType === "PenaltyShot");
			penaltiesToDelete.forEach((current, index, array) => {
				penalties.splice(penalties.findIndex(x => x.Id === current.Id), 1);
			});
			this.setState({
				showPenalties: true, 
				penaltyShootOutOccurring: true, 
				penalties: penalties});
		}
	}

	populateLatestScores = (data) => {
		console.debug('Data received and populating latest scores');
		console.debug(data);

		this.setState({
			displayMinute: data.DisplayMinutes,
			score: data.home.score + " - " + data.away.score,
			homeScorers: data.home.scorers,
			awayScorers: data.away.scorers,
			showScorers: true,
			homeShortName: data.home.shortName,
			awayShortName: data.away.shortName,
			homeName: data.home.name,
			awayName: data.away.name,
			aggregateScore: data.home.aggregateScore + " - " + data.away.aggregateScore,
			showAggregateScore: (data.ShowAggregateScore && data.home.aggregateScore !== undefined && data.away.aggregateScore !== undefined)
		});
	}

	populateLatestResults = (data) => {
		this.setState({
			latestResults: data
		});
	}

	render() {
		var mainContent = null;
		if(this.state.showSpinner) {
			mainContent = <img src={spinner} className="spinner" alt="" />
		}

		if(this.state.showError) {
			mainContent = <p className="error">No data found</p>
		}

		if(this.state.showPenalties) {
			mainContent = <Penalties penalties={this.state.penalties} displayMinute={this.state.displayMinute} awayCrestUrl={this.state.awayCrestUrl} homeCrestUrl={this.state.homeCrestUrl} aggregateScore={(this.state.showAggregateScore ? this.state.aggregateScore : '')} />
		} 
		else if(this.state.showScorers) {
			mainContent = <LatestScores homeScorers={this.state.homeScorers} awayScorers={this.state.awayScorers} displayMinute={this.state.displayMinute} score={this.state.score} aggregateScore={(this.state.showAggregateScore ? this.state.aggregateScore : '')} awayCrestUrl={this.state.awayCrestUrl} homeCrestUrl={this.state.homeCrestUrl} homeName={this.state.homeName} awayName={this.state.awayName} homeShortName={this.state.homeShortName} awayShortName={this.state.awayShortName} />     
		}

		var summaryContent = null;
		if(this.state.showPenalties) {
			summaryContent = <button onClick={this.handleBack}>Back to match</button>
		}
		if(!this.state.showPenalties && this.state.penaltyShootOutOccurring) {
			summaryContent = <button onClick={this.handleBack}>Back to penalties</button>
		}

		return (
			<div className={"LiveGameSummary"  + (this.state.showSelf ? "" : " hide")}>
				<div className="LiveGameSummary__outerwrapper">
					<div className="LiveGameSummary__wrapper">
						{mainContent}    
					</div>
					<div className="LiveGameSummary__summary">
						{summaryContent}
						<LatestResults results={this.state.latestResults} />
					</div>
				</div>
			</div>
		)
	}
}

module.exports = LiveGameSummaryModule;



// WEBPACK FOOTER //
// ./src/components/MDC/LiveGameSummary/LiveGameSummaryModule.js